import React from "react";
import { BrandDetail } from "~/common/Store/models/Brand";
import ExpandedBrandPage from "./ExpandedBrandPage";

const BrandGroupPage = (props: BrandDetail) =>
  ({ ...props }.expandedPageAttributes.isExpandedBrand ? (
    <>
      <ExpandedBrandPage {...props} />
    </>
  ) : null);

export default BrandGroupPage;
